import client from '../client';
import { exportFile } from '../requestDownloadFile';
export default {
  getCpcCampaigns: data => {
    return client.get('publisher/cpc/campaigns/discover', { params: data }).then(res => res.data);
  },
  // 未加入的 Campaign 详情
  preJoinDetail: data => {
    return client.get(`publisher/cpc/campaigns/${data.campaignId}/pre-join-detail`, { params: data }).then(res => res.data);
  },
  // 加入Campaign
  joinCpcCampaign: data => {
    return client.post(`publisher/cpc/campaigns/${data.campaignId}/join`, data).then(res => res.data);
  },
  //My Campaigns 列表
  getMyCpcCampaigns: data => {
    return client.get('publisher/cpc/campaigns/my-campaigns', { params: data }).then(res => res.data);
  },
  // 已加入的 Campaign 详情概览
  getJoinedOverview: data => {
    return client.get(`publisher/cpc/campaigns/${data.campaignId}/joined-overview`, { params: data }).then(res => res.data);
  },
  // 特定 Campaign 的 Product Links列表
  getJoinedProductLinks: data => {
    return client.get(`publisher/cpc/campaigns/${data.campaignId}/joined-product-links`, { params: data }).then(res => res.data);
  },
  //重试生成 Campaign 指定商品链接
  retryGenerateProductLinks: data => {
    return client.post(`publisher/cpc/campaigns/${data.campaignId}/products/${data.productId}/regenerate-links`, data).then(res => res.data);
  },
  //特定 Campaign 的 Reporting 列表
  getJoinedReporting: data => {
    return client.get(`publisher/cpc/campaigns/${data.campaignId}/joined-reporting`, { params: data }).then(res => res.data);
  },
  //特定 Campaign 的 Progress数据
  getJoinedReportingDetail: data => {
    return client.get(`publisher/cpc/campaigns/${data.campaignId}/joined-progress`, { params: data }).then(res => res.data);
  },
  //导出
  exportCampaigns: (fileName, data) => { 
    return exportFile(`publisher/cpc/campaigns/${data.campaignId}/joined-reporting/export`, data, fileName)
    // return client.post('publisher/product/export',data).then(res=>console.log(res));
  },
  exportProductLinks: (fileName, data) => {
    return exportFile(`publisher/cpc/campaigns/${data.campaignId}/joined-product-links/export`, data, fileName)
  },
}